<div class="container min-vh-100" style="background-color: black;">
    <app-nav-header [isBackButton]="isBackButton" [isTitle]="isTitle" [isLogo]="isLogo"></app-nav-header>
    <router-outlet></router-outlet>
    <app-nav-footer></app-nav-footer>
</div>